export default "__VITE_ASSET__COtQSk7z__"